import SendingReceiptMail from '@/components/common/SendingReceiptMail';
import SectionCard from '@/components/LocationPrint/SectionCard';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import {
  LOCATION_PRINT,
  LOCATION_PRINT_DETAIL,
  LocationPrintAirport,
} from '@/constants/print.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { TextButton } from '@repo/components';
import { isRefundableAirport } from '@repo/utils';
import { Icon } from '@successmode-ktp/kui';
import { useState } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

const LocationPrint = () => {
  const { nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const [selectLocation, setSelectLocation] =
    useState<LocationPrintAirport>('ICN_TERMINAL1');
  const [sendingStatus, setSendingStatus] = useState<'DEFAULT' | 'IS_SENDING'>(
    'DEFAULT',
  );

  const isAirportTour =
    passportNumber && isRefundableAirport(localStorage.getItem(passportNumber));

  const history = useHistory();

  return (
    <ReceiptLayout>
      <Title>
        <button type='button' onClick={() => history.goBack()}>
          <Icon.ChevronLeft />
        </button>
        {nationality === 'KOR'
          ? '공항 프린트기 위치'
          : 'Airport Printer Location'}
        <div style={{ width: '24px' }} />
      </Title>
      <BadgeWrapper>
        {LOCATION_PRINT.map(({ key, name, nameKor }) => (
          <li key={key}>
            <Badge
              type='button'
              onClick={() => setSelectLocation(key)}
              isSelected={key === selectLocation}
            >
              {nationality === 'KOR' ? nameKor : name}
            </Badge>
          </li>
        ))}
      </BadgeWrapper>
      <LocationWrapper>
        {LOCATION_PRINT_DETAIL[selectLocation].map((printData, index) => {
          return (
            <li key={index}>
              <SectionCard
                type={printData.type}
                location={printData.location}
                time={printData.time}
                tel={printData.tel}
                imgSrc={printData.img}
                mapSrc={printData.map}
              />
            </li>
          );
        })}
      </LocationWrapper>
      {isAirportTour || (
        <>
          <ButtonWrapper>
            <TextButton
              title='이메일로 영수증 전송'
              onClick={() => setSendingStatus('IS_SENDING')}
            />
          </ButtonWrapper>
          {sendingStatus === 'IS_SENDING' && (
            <SendingReceiptMail
              setSendingStatus={setSendingStatus}
              isActiveLoadingView={false}
            />
          )}
        </>
      )}
    </ReceiptLayout>
  );
};

export default LocationPrint;

const Title = styled.strong`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  color: #3a3b3e;
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

const BadgeWrapper = styled.ul`
  display: flex;
  gap: 6px;
  width: 100%;
  margin: 16px auto 20px;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Badge = styled.button<{ isSelected: boolean }>`
  padding: 6px 16px;
  border-radius: 6px;
  background: ${({ isSelected }) => (isSelected ? '#3a3b3e' : '#F5F6F7')};
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#A7A7A7')};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
  white-space: nowrap;
`;

const LocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0px 0 100px;
  list-style: none;
`;

const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
`;
